import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-twitter-login-callback',
  templateUrl: './twitter-login-callback.component.html'
})
export class TwitterLoginCallbackComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
